import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { WelcomeScreenBackground } from "@/components/Layout/WelcomeScreen/Background/WelcomeScreenBackground";
import { HeroSection } from "@/components/Layout/WelcomeScreen/HeroSection/HeroSection";
import { WelcomeScreenFooter } from "@/components/Layout/WelcomeScreenFooter/WelcomeScreenFooter";
import { useIsMobile } from "@/hooks/useIsMobile";
import { FCC } from "@/types";

import { LogInForm } from "./LogInForm";
import { RegisterForm } from "./RegisterForm";

const InfoBlock = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-lg text-white md:text-black xs:mt-10">
        <Trans
          t={t}
          i18nKey="Content.welcomeText"
          components={[
            <a
              key="ratesLink"
              href={t("Content.ratesLink")}
              className="font-semibold text-highlight-100 underline md:text-secondary-100"
              target="_blank"
              rel="noreferrer"
            />,
          ]}
        />
      </p>
      <p className="mb-10 text-lg text-white md:pt-6 md:text-black">
        {t("Content.welcomeTextEsimUpsell")}
      </p>
    </>
  );
};

export const WelcomeScreen: FCC = () => {
  const { t } = useTranslation();
  const [switchForm, setSwitchForm] = useState(true);
  const isMobile = useIsMobile();

  return (
    <WelcomeScreenBackground>
      <div className="flex min-h-screen flex-col" data-testid="welcome-content">
        <div className="flex flex-grow flex-col px-10 md:flex-row">
          <div className="md:w-[600px] md:flex-none md:shrink-0">
            <HeroSection
              textsToAnimate={[
                t("newWelcome.heroText.firstAnimation"),
                t("newWelcome.heroText.secondAnimation"),
              ]}
            />
            <div className="md:max-w-[70%]">
              {!isMobile && <InfoBlock />}

              <div className="hidden md:absolute md:bottom-10 md:z-[51] md:block">
                <p className="text-lg text-black">{t("Content.products")}</p>
                <a
                  href={t("Content.shopLink")}
                  className="text-lg font-semibold text-secondary-100 hover:underline"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("Content.shop")}
                </a>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center md:min-w-0 md:flex-1">
            {switchForm ? (
              <LogInForm>
                <p className="text-xs text-white">
                  <span className="mr-1">
                    {t("newWelcome.logInForm.noAccount")}
                  </span>
                  <a
                    onClick={() => setSwitchForm(!switchForm)}
                    target="_self"
                    rel="noreferrer"
                    className="inline cursor-pointer text-xs font-semibold text-highlight-100 focus-within:underline hover:underline focus:underline focus-visible:underline active:underline"
                  >
                    {t("newWelcome.logInForm.registerNow")}
                  </a>
                </p>
              </LogInForm>
            ) : (
              <RegisterForm
                handleVerifyEmailModalClose={() => setSwitchForm(!switchForm)}
              >
                <p className="text-xs text-white">
                  <span className="mr-1">
                    {t("newWelcome.registerForm.accountExists")}
                  </span>
                  <a
                    onClick={() => setSwitchForm(!switchForm)}
                    target="_self"
                    rel="noreferrer"
                    className="inline cursor-pointer text-xs font-semibold text-highlight-100 focus-within:underline hover:underline focus:underline focus-visible:underline active:underline"
                  >
                    {t("newWelcome.registerForm.logInNow")}
                  </a>
                </p>
              </RegisterForm>
            )}
          </div>
        </div>
        {isMobile && (
          <div className="px-10">
            <InfoBlock />
          </div>
        )}
        <WelcomeScreenFooter
          link={t("Content.shopLink")}
          text={t("Content.products")}
          linkText={t("Content.shop")}
        />
      </div>
    </WelcomeScreenBackground>
  );
};
